import { BaseApiClient } from '@/services/baseApiClient';
import type { RequestOptions } from '@/utils/request';
import { getQuery } from '@/components/filter/helpers';
import type { DeleteRemoteReadingValueArgs, GetRemoteReadingValuesArgs } from './types/args';
import type { DeleteRemoteReadingValueResult, GetRemoteReadingValuesResult } from './types/results';

export class RemoteReadingValuesApiClient extends BaseApiClient {
  constructor() {
    super('api/records/sensor/value');
  }

  public get(
    filter: GetRemoteReadingValuesArgs,
    signal: RequestOptions['signal'],
  ): Promise<GetRemoteReadingValuesResult> {
    return this.http.get('', { query: getQuery({ ...filter }), signal });
  }

  public delete(id: DeleteRemoteReadingValueArgs): Promise<DeleteRemoteReadingValueResult> {
    return this.http.delete(`${id}`);
  }
}
